module.exports = __webpack_public_path__ + "img/8.4c9e6b33.png";